module.exports = __webpack_public_path__ + "img/agent.78680237.png";